import { ref } from 'vue'

export function useLoading<T, U>(loadData: (params?: U) => Promise<T>) {
  const loading = ref(false)
  const load = async (params?: U) => {
    loading.value = true
    await loadData(params)
    loading.value = false
  }
  return { loading, load }
}
